import { useFeatureFlag } from "./useFeatureFlag";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";

/**
 * Where the portfolio opens.
 *
 * Trials is the portfolio's front door for every tenant, except those on
 * SITE_FIRST_NAV: for a site-intelligence tenant the portfolio *is* the site
 * list, so both the post-login redirect and every "go to the portfolio" link
 * land on Sites instead.
 *
 * The flag is read across all available trials (`anyTrialFeature`) because the
 * callers run before a trial scope exists.
 */
export function usePortfolioLandingPath(): string {
  const siteFirst = useFeatureFlag(FEATURE_FLAGS.SITE_FIRST_NAV, true);
  return siteFirst ? "/portfolio/site-profiles" : "/portfolio/trials";
}
